import axios from "axios";

const state = {
  onBoardings: [],
  onBoarding: {},
  loading: false,
  merchantOnBoardings: [],
  merchantOnBoarding: {}
};

const getters = {
  allOnBoardings: (state) => state.onBoardings,
  onBoardingData: (state) => state.onBoarding,
  loading: (state) => state.loading,

  allMerchantOnBoardings: (state) => state.merchantOnBoardings,
  merchantOnBoardingData: (state) => state.merchantOnBoarding
};

const actions = {
  getOnBoardings({ commit }) {
    commit('setLoading', true)
    axios.get("/api/panel/onboarding/list").then((response) => {

      commit("setOnBoardings", response.data.payload);
      commit('setLoading', false)
    });
  },

  addOnBoarding({ commit }, onBoardingData) {
    var bodyFormData = new FormData();
    if (onBoardingData.img != undefined && onBoardingData.img != null) {
      bodyFormData.set("img", onBoardingData.img);
    }
    if (
      onBoardingData.animation != undefined &&
      onBoardingData.animation != null
    ) {
      bodyFormData.set("animation", onBoardingData.animation);
    }
    console.log("onBoarding", onBoardingData);
    bodyFormData.set("title", onBoardingData.title);
    bodyFormData.set("description", onBoardingData.description);
    if (onBoardingData.link && onBoardingData.linkText) {
      bodyFormData.set("link", onBoardingData.link);
      bodyFormData.set("linkText", onBoardingData.linkText);
    }
    bodyFormData.set("ordering", parseInt(onBoardingData.ordering));
    return axios
      .post("/api/panel/onboarding", bodyFormData)
      .then((response) => {
        return response.data;
      });
  },
  updateOnBoarding({ commit }, onBoardingData) {


    var bodyFormData = new FormData();
    if (onBoardingData.img != undefined && onBoardingData.img != null) {
      bodyFormData.set("img", onBoardingData.img);
    }
    if (
      onBoardingData.animation != undefined &&
      onBoardingData.animation != null
    ) {
      bodyFormData.set("animation", onBoardingData.animation);
    }
    bodyFormData.set("id", onBoardingData.id);
    bodyFormData.set("title", onBoardingData.title);
    bodyFormData.set("description", onBoardingData.description);
    if (onBoardingData.link && onBoardingData.linkText) {
      bodyFormData.set("link", onBoardingData.link);
      bodyFormData.set("linkText", onBoardingData.linkText);
    }
    bodyFormData.set("active", onBoardingData.active);
    bodyFormData.set("ordering", parseInt(onBoardingData.ordering));
    return axios
      .put("/api/panel/onboarding", bodyFormData)
      .then((response) => {
        return response.data;
      });
  },
  deleteOnBoarding({ commit }, onBoardingData) {
    console.log("onBoarding", onBoardingData);


    return axios.post("/api/panelOnBoarding/postDeleteOnBoarding", {
      id: onBoardingData.id,
    });
  },
  getOnBoarding({ commit }, onBoardingId) {
    console.log("onBoardingId", onBoardingId);
    axios
      .get(`/api/panel/onboarding/${onBoardingId}`)
      .then((response) => {
        commit("setOnBoarding", response.data.payload);
      }).catch(err => {
        console.log("err", err);
      });
  },

  getMerchantOnBoardings({ commit }) {
    commit('setLoading', true)
    axios.get("/api/panel/merchant-on-boarding/list").then((response) => {

      commit("setMerchantOnBoardings", response.data.payload);
      commit('setLoading', false)
    });
  },
  addMerchantOnBoarding({ commit }, onBoardingData) {
    const formData = new FormData();
    Object.keys(onBoardingData).map((key) => {
      formData.append(key, onBoardingData[key])
    })
    return axios
      .post("/api/panel/merchant-on-boarding", formData)
      .then((response) => {
        return response.data;
      });
  },
  putMerchantOnBoarding({ commit }, onBoardingData) {
    const formData = new FormData();
    Object.keys(onBoardingData).map((key) => {
      if (onBoardingData[key]) {
        formData.append(key, onBoardingData[key])
      }
    })
    return axios
      .put("/api/panel/merchant-on-boarding", formData)
      .then((response) => {
        return response.data;
      });
  },
  getMerchantOnBoarding({ commit }, onBoardingId) {

    return axios
      .get(`/api/panel/merchant-on-boarding/${onBoardingId}`)
      .then((response) => {
        commit("setMerchantOnBoarding", response.data.payload);
        return response.data.payload;
      }).catch(err => {
      });
  },
};
const mutations = {
  setOnBoardings: (state, onBoardings) => (state.onBoardings = onBoardings),
  setOnBoarding: (state, onBoarding) => {
    state.onBoarding = onBoarding;
    if (state.onBoarding.imgUrl != null) {
      state.onBoarding.imgUrl = state.onBoarding.imgUrl + "?x=" + Date.now();
    }
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setMerchantOnBoardings: (state, merchantOnBoardings) => (state.merchantOnBoardings = merchantOnBoardings),
  setMerchantOnBoarding: (state, merchantOnBoarding) => {
    state.merchantOnBoarding = merchantOnBoarding;
    if (state.merchantOnBoarding.imgUrl != null) {
      state.merchantOnBoarding.imgUrl = state.merchantOnBoarding.imgUrl + "?x=" + Date.now();
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
